module.exports = __webpack_public_path__ + "img/mv-logo-light.ceed0da3.png";